function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M18 7.985a1.01 1.01 0 0 1-1 1h-1l.022 5.007a2.293 2.293 0 0 1-.016.253v.5A1.25 1.25 0 0 1 14.751 16h-2.5A1.25 1.25 0 0 1 11 14.751V12a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v2.75A1.25 1.25 0 0 1 5.75 16H4c-.047 0-.094 0-.141-.006S3.788 16 3.75 16h-.5A1.25 1.25 0 0 1 2 14.751v-3.5a.819.819 0 0 1 0-.088V8.988H1a.988.988 0 0 1-1-1 1.016 1.016 0 0 1 .313-.75L8.326.25A.9.9 0 0 1 9.013 0a1.038 1.038 0 0 1 .657.219l7.982 7.016a.856.856 0 0 1 .348.75z",
    transform: "translate(3 3.999)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.362d001a01496eec1f277a3289be3a79.svg";
export { ForwardRef as ReactComponent };